(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/button-label-toggle
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Basic button label content toggle.
 * @copyright 2023 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("button-label-toggle") === undefined) {
    class ButtonLabelToggle extends HTMLElement {
        constructor(){
            super();
            this.button = this.querySelector("button");
            this.labels = this.button.children;
            this.button?.addEventListener("click", this.clickEvent.bind(this), false);
        }
        clickEvent() {
            Array.from(this.labels).forEach((label)=>label.hidden == true ? label.hidden = false : label.hidden = true);
        }
    }
    customElements.define("button-label-toggle", ButtonLabelToggle);
}



})();
